// import GoogleMapsLoader from 'google-maps'

// const Maps = () => {
//   const container = document.querySelector('.js-map')

//   if (container) {
//     GoogleMapsLoader.KEY = 'AIzaSyAHb1rgAThri-yW_7QC513HiUGz9rcevLw'

//     GoogleMapsLoader.load((google) => {
//       const latLng = {lat: 52.2640367, lng: 5.7838212}
//       const map = new google.maps.Map(container, {  // eslint-disable-line
//         zoom: 17,
//         center: latLng,
//         disableDefaultUI: true,
//         draggable: false,
//         zoomControl: false,
//         scrollwheel: false,
//         disableDoubleClickZoom: true
//       })

//       const marker = new google.maps.Marker({ // eslint-disable-line
//         position: latLng,
//         map: map
//       })
//     })
//   }
// }

// export default Maps


export default () => {
  const maps = document.querySelector('.js-maps')
  const singleMap = document.querySelector('.js-single-maps')
  let infowindows = []

  if (!maps && !singleMap) {
    return
  }

  const script = document.createElement('script')
  script.src = `https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyAHb1rgAThri-yW_7QC513HiUGz9rcevLw&callback=mapsCallback`
  document.body.appendChild(script)

  window.mapsCallback = () => {
    if (maps) {
      displayMaps()
    }
    if (singleMap) {
      displaySingleMap()
    }
  }

  const createMarkers = map => {
    const projectTypes = ['project', 'cases']
    projectTypes.forEach(type => {
      fetchMarkers(type, map)
    })
  }

  const fetchMarkers = (type, map) => {
    window
      .fetch(`/wp-json/wp/v2/${type}?per_page=99`, {
        credentials: 'same-origin'
      })
      .then(response => {
        response.json().then(r => {
          ;[...r].forEach(item => {
            console.log(item)
            const icon = {
              url:
                type === 'project'
                  ? '/wp-content/themes/bronkhorst/img/black-circle.svg'
                  : '/wp-content/themes/bronkhorst/img/gold-circle.svg', // url
              scaledSize: new window.google.maps.Size(10, 10), // scaled size
              origin: new window.google.maps.Point(0, 0), // origin
              anchor: new window.google.maps.Point(0, 0) // anchor
            }
            const marker = new window.google.maps.Marker({
              map,
              position: {
                lat:
                  type === 'project'
                    ? item.project_meta ? Number(item.project_meta.latitude) : 0
                    : item.case_meta ? Number(item.case_meta.latitude) : 0,
                lng:
                  type === 'project'
                    ? item.project_meta ? Number(item.project_meta.longitude) : 0
                    : item.case_meta ? Number(item.case_meta.longitude) : 0
              },
              icon: icon
            })
            const anchor_text = maps.dataset.view
            const contentString =
              type === 'project'
                ? `
            <div class="c-map__project-info">
              <div class="c-map__project-info-title">${
                item.title.rendered
              }</div>
              <a class="c-map__project-info-link" href="${
                item.link
              }">${anchor_text}
                <svg class="icon c-icon c-map__project-info-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-right"></use></svg>
              </a>
            </div>
          `
                : `
          <div class="c-map__project-info">
            <div class="c-map__project-info-title">${item.title.rendered}</div>
          </div>
        `
            let infowindow = null

            window.google.maps.event.addListener(marker, 'click', () => {
              if (infowindows.length) {
                ;[...infowindows].forEach(item => {
                  item.close()
                })
              }
              infowindow = new window.google.maps.InfoWindow({
                content: contentString
              })
              infowindows.push(infowindow)
              infowindow.open(map, marker)
            })

            return marker
          })
        })
      })
  }

  const displaySingleMap = () => {
    var lat = 52.2640367
    var lng = 5.7838212

    // google maps styling
    const styles = [
      {
        stylers: [{ hue: '#cccccc' }, { saturation: -100 }]
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ lightness: 10 }, { visibility: 'simplified' }]
      },
      {
        featureType: 'road',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      }
    ]
    const coordinates = {
      lat: lat,
      lng: lng
    }
    const options = {
      zoom: 10,
      center: new window.google.maps.LatLng(coordinates.lat, coordinates.lng),
      scrollwheel: false,
      draggable: false,
      zoomControl: false,
      scaleControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      styles: styles
    }
    const map = new window.google.maps.Map(
      document.getElementById('maps'),
      options
    )

    const image = '/wp-content/themes/bronkhorst/img/gold-circle.svg'

    const greenMarker = new window.google.maps.Marker({
      map: map,
      icon: image,
      position: {
        lat: coordinates.lat,
        lng: lng
      }
    })

    return greenMarker
  }

  const displayMaps = () => {

    let zoom = 8

    // google maps styling
    const styles = [
      {
        stylers: [{ hue: '#cccccc' }, { saturation: -100 }]
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ lightness: 10 }, { visibility: 'simplified' }]
      },
      {
        featureType: 'road',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      }
    ]
    const coordinates = {
      lat: 52.402468,
      lng: 5.6004213
    }
    const options = {
      zoom: zoom,
      center: new window.google.maps.LatLng(coordinates.lat, coordinates.lng),
      scrollwheel: false,
      draggable: true,
      zoomControl: true,
      scaleControl: true,
      styles: styles
    }
    const map = new window.google.maps.Map(
      document.getElementById('maps'),
      options
    )
    createMarkers(map)
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/Map.js